const types = {
  OFF_PREVIEW_MODE: "OFF_PREVIEW_MODE",
  ON_PREVIEW_MODE: "ON_PREVIEW_MODE",
};

export default types;
